<template>
  <div id="slide-4" class="slide pt-37.5 px-23.5 h-screen relative flex-col">
    <div
      class="clients-left flex flex-col"
    >
      <p
          class="uppercase fz-10 font-medium"
          style="letter-spacing: 2px; color: rgba(110, 117, 141, 1)"
      >
        {{ text.ourClients }}
      </p>
      <div class="flex my-12.5 justify-between">
        <p class="fz-16 w-84" style="line-height: 1.5rem">
          {{ text.trust }}
        </p>
        <div class="flex items-center gap-2.5">
          <h2
              class="flex"
              style="font-size: 4rem; color: #ff2e53; line-height: 4rem"
          >
            {{ text.realizedCount }}
          </h2>
          <p
              class="font-medium uppercase fz-10"
              style="line-height: 200%; color: rgba(192, 197, 216, 1)"
          >
            {{ text.realizedText[0] }} <br />
            {{ text.realizedText[1] }}
          </p>
        </div>
      </div>



    </div>
    <slider
        :slides-container-classes="'mb-5'"
        :slider-classes="'w-full relative tablet-companies-slider'"
        :similar-slides="true"
        :pagination="true"
        pagination-container-classes="gap-5 pl-4.5"
        class="mb-12.5"
    >
      <template v-slot:slides>
        <div
            class="slider-slide w-85 grid grid-rows-2 grid-cols-2"
            v-for="(item, index) in text.clientSliderM"
            :key="item"
        >
          <div class="w-42.5 h-42.5" v-for="(subItem, subIndex) in item" :class="subItem.opacity" :key="index + subIndex">
            <img :src="require('@/assets/images/slide_3/' + subItem.image + '.png')" style="width: inherit; height: inherit" class="client-list-item" alt="">
          </div>
        </div>
      </template>
      <template v-slot:pagination>
        <div class="w-1.25 h-1.25 rounded-full bg-white"></div>
      </template>
    </slider>
    <div class="become-client w-max flex flex-row ml-auto items-center gap-5" @click="toggleContacts">
      <div class="plus relative w-12.5 h-12.5 rounded-full" style="background:#ff2e53;" >
        <div class="w-4 h-2px absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#fff;"></div>
        <div class="w-2px h-4 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#fff;"></div>
      </div>
      <p class="uppercase fz-13 font-semibold" style="line-height: 1.539;">{{ text.become }}</p>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import slider from "@/components/tablet/reuseable/slider";


export default {
  name: "slide4",
  components:{slider},
  props: ["clientSlide"],
  computed: {
    ...mapState(['lang']),
    text() {
      return require("@/assets/text/main/slide3/" + this.lang + ".json");
    },
  },
  methods:{
    ...mapMutations(['toggleContacts'])
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  transition: all linear 0.3s;
  background: #fff;
}
.pagination > div > * {
  transition: all linear 0.3s;
}
.pagination .active {
  width: 2.5rem;
  height: 0.25rem;
  background: rgba(255, 46, 83, 1);
}

.first {
  background: rgba(110, 117, 141, 0.1);
}
.second {
  background: rgba(110, 117, 141, 0.2);
}
.client-list-item{
  transform: scale(0.88089);
  transform-origin: center;
}

.tablet-companies-slider::before, .tablet-companies-slider::after{
  z-index: 87;
  content: '';
  position: absolute;
  height: 100%;
  width: 5.875rem;
  top: 0;
  bottom: 0;
  background: linear-gradient(270deg, #020306 0%, rgba(2, 3, 6, 0) 100%);
}
.tablet-companies-slider::before{
  right: 100%;
  transform: rotate(-180deg);
}
.tablet-companies-slider::after{
  left: 100%;
}
</style>
